// パネルリスト取得
let PanellistEstateElems = Array.from(document.getElementsByClassName('panel-list'));
let listElems = Array.from(document.getElementsByClassName('panel-list'));
let marginRightNum = [];

const getMarginRight = (ulElem) => {
    let liElems = Array.from(ulElem.children);
    if (liElems.length != 0) {
        marginRightNum.push(getComputedStyle(liElems[0]).getPropertyValue("margin-right"));
    }
}
const marginRight = () => {
    PanellistEstateElems.forEach(PanellistEstateElems => {
        getMarginRight(PanellistEstateElems);
    });

}
window.addEventListener('load', marginRight);
window.addEventListener('resize', marginRight);

const PanelListLeftJustifiedEstate = (ulElem, liElems) => {
        // アイテムのmargin-rightを取得
        let liMarginRightStr = window.getComputedStyle(liElems[0]).getPropertyValue('margin-right');
        let liMarginRightNum = Number(liMarginRightStr.replace('px', ''));

        // アイテムのwidthを配列化
        let liWidthNums = liElems.map((v) => {
            return v.getBoundingClientRect().width + liMarginRightNum;
        })

        for (let i = 0; i < liElems.length; i++) {
            liElems[i].style.marginRight = "";
        }

        let lastLineIndexNum = [];
        liWidthNums.reduce((prev, cur, curIndex) => {
            if (ulElem.getBoundingClientRect().width <= prev + cur ) {
                if (ulElem.getBoundingClientRect().width > Math.floor(prev + (cur - liMarginRightNum))) {
                    lastLineIndexNum.push(curIndex);
                    return prev = 0;
                } else if(ulElem.getBoundingClientRect().width == Math.floor(prev + (cur - liMarginRightNum))){
                    lastLineIndexNum.push(curIndex);
                    return prev = 0;
                } else {
                    lastLineIndexNum.push(curIndex - 1);
                    return prev = liWidthNums[curIndex];
                }
            } else {
                return prev + cur ;
            }
            })
            if (lastLineIndexNum[0] == undefined) {
                liElems[liElems.length - 1].style.marginRight = '0px';
            } else {
                for (let i = 0; i < lastLineIndexNum.length; i++) {
                    liElems[lastLineIndexNum[i]].style.marginRight = '0px';
                }
            }
}

const PanelListEstateflexed = () => {
    PanellistEstateElems.forEach(listElem => {
        // パネルリスト アイテムの配列
        let itemElems = Array.from(listElem.children);
        if (itemElems.length != 0) {
            PanelListLeftJustifiedEstate(listElem, itemElems);
        }
    });

}
window.addEventListener('load', PanelListEstateflexed);
window.addEventListener('resize', PanelListEstateflexed);
